<template>
  <div id="app">
    <el-container class="box">
      <el-aside width="130px" v-if="checkLogin()">
        <el-menu id="nav">
          <div v-for="(item,index) in config" :key="item.title">
            <hr v-if="checkAuth()>=1&&index===3"></hr>
            <el-menu-item v-if="checkAuth()>=item.auth">
              <router-link :to="item.path">{{ item.title }}</router-link>
            </el-menu-item>
          </div>
        </el-menu>

      </el-aside>
      <el-container>
        <el-header class="header">
          <div>
            台沛訂單管理系統
          </div>
          <div v-if="checkLogin()" class="accountFunc">
            <el-dropdown>

              <i class="el-icon-user-solid" style="margin-right: 10px;font-size:36px;color:#de887b"></i>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <ResetPw/>
                </el-dropdown-item>
                <el-dropdown-item>
                  <Logout/>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span>{{ id() }}</span>
          </div>
        </el-header>
        <router-view/>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import {getAuth, getId, isLogin} from "@/api";
import ResetPw from "@/components/ResetPw";
import Logout from "@/components/Logout";

export default {
  components: {ResetPw, Logout},
  data() {
    return {
      config: [
        {path: '/', title: 'Home', auth: 0},
        {path: '/user', title: 'APP用戶管理', auth: 0},
        {path: '/order', title: '訂單管理', auth: 0},
        {path: '/account', title: '職員設定', auth: 1},
        {path: '/store', title: '商品設定', auth: 2},
        {path: '/announce', title: '公告設定', auth: 2},
      ]
    }
  },
  methods: {
    checkLogin() {
      return isLogin()
    },
    checkAuth() {
      return getAuth()
    },
    id() {
      return getId()
    }
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.box {
  min-height: 600px;
}

#nav {
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: right;
  font-size: 22px;
  background-color: #f9f5f6;
  height: 40px;
  color: #9b9798;
  font-weight: bold;
}

.footer {
  position: fixed;
  bottom: 0px;
}
</style>
